import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-reject-reason-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule, // Import MatButtonModule for buttons
  ],
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <h2 mat-dialog-title>Reject Document</h2>
      </div>

      <div class="dialog-content">
        <mat-dialog-content>
          <p>Please provide a reason for rejecting this document:</p>
          <mat-form-field appearance="outline" class="full-width">
            <input matInput [(ngModel)]="data.reason" placeholder="Reason" />
          </mat-form-field>
        </mat-dialog-content>
      </div>

      <div class="dialog-actions">
        <mat-dialog-actions align="end">
          <button mat-button (click)="onNoClick()">Cancel</button>
          <button mat-button [mat-dialog-close]="data" color="primary" cdkFocusInitial>
            Submit
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  `,
  styles: [
    `
      .dialog-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 500px; /* Adjust as needed */
        padding: 16px;
      }

      .dialog-header {
        text-align: center;
        margin-bottom: 16px;
      }

      .dialog-content {
        flex: 1;
        margin-bottom: 16px;
      }

      .full-width {
        width: 100%;
      }

      .dialog-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
      }
    `,
  ],
})
export class RejectReasonDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RejectReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { reason: string }
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}